import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetAllOfficesStatus = () => {
  return useQuery(["GetAllOfficesStatus", {}], searchOfficeSettings, {
    refetchOnWindowFocus: false,
  });
};
export default useGetAllOfficesStatus;
